import React from "react";
import { GrDocumentPdf } from "react-icons/gr";
import { useToggle } from "../../../hooks/useToggle";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SALES } from "../../../constant/routes";

type Props = {
  id: string;
};

const PdfDropdown = ({ id }: Props) => {
  const { ref, isOpen, setIsOpen } = useToggle();
  return (
    <div ref={ref} style={{ position: "relative" }}>
      <GrDocumentPdf
        className="edit-icon"
        color="#000"
        onClick={() => setIsOpen((prev) => !prev)}
        cursor="pointer"
      />
      {isOpen && (
        <StyledDropdown>
          <Link to={`${SALES.pdf}/${id}`}>Προσφορά BFLOW</Link>
          <Link to={`${SALES.customerPdf}/${id}`}>Προσφορά Πελάτη</Link>
        </StyledDropdown>
      )}
    </div>
  );
};

export default PdfDropdown;

const StyledDropdown = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: calc(100% + 2px);
  right: 0;
  background-color: #fff;
  border: 1px solid var(--border-light-gray);
  border-radius: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 10px 0;
  z-index: 1;
  width: max-content;
  text-align: left;

  a {
    padding: 8px 20px;
    text-decoration: none;
    color: #000;
    transition: all 0.2s;

    &:hover {
      background-color: #dbf4fd;
    }
  }
`;
